import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'

import {PRICE_ALERT_PROMPT_COMPONENT} from './constants'

interface TrackArgs {
  hotelId?: string
}

export const trackPriceAlertPromptDisplayed = ({hotelId}: TrackArgs) =>
  trackEvent({
    category: Category.System,
    entity: Entity.PriceAlertPrompt,
    action: Action.Displayed,
    team: Team.Retention,
    page: Page.Accommodation,
    component: PRICE_ALERT_PROMPT_COMPONENT,
    payload: {hotelId}
  })
